import { AdResFinishPage } from './AdResFinishPage';

export const adResFinishRouter = {
  '/@/advance_reservation_finish': AdResFinishPage,
};
